import { createContext, useReducer } from 'react';

export const JobDetailContext = createContext(null);

const initialState = {
	selectedJobId: null,
	selectedJob: null,
	loading: false,
	error: null,
};

const reducer = (state, action) => {
	switch (action.type) {
		case 'SET_SELECTED_JOB_ID':
			return { ...state, selectedJobId: action.payload };
		case 'SET_JOB':
			return { ...state, selectedJob: action.payload };
		case 'SET_LOADING':
			return { ...state, loading: action.payload };
		case 'SET_ERROR':
			return { ...state, error: action.payload };
		default:
			return state;
	}
};

const JobDetailProvider = ({ children }) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	return (
		<JobDetailContext.Provider value={{ state, dispatch }}>
			{children}
		</JobDetailContext.Provider>
	);
};

export { JobDetailProvider };
